import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-danger-ladder',
    templateUrl: './pr-danger-ladder.component.html',
    styleUrls: ['./pr-danger-ladder.component.scss'],
    standalone: false
})
export class PrDangerLadderComponent implements OnInit {
  @Input() dangerRange = [0, 11, 30, 41, 45];
  @Input() value: number = 30;

  constructor() {}

  ngOnInit(): void {}
}
